import { useState } from "react";
import { useCurrentOrganization } from "src/contexts/OrganizationContext";
import PractitionerInfoModal from "../modals/PractitionerInfoModal";

type PractitionerLinkProps = {
  name: string;
  practitionerId?: string | null;
};

const PractitionerLink = ({ name, practitionerId }: PractitionerLinkProps) => {
  const organization = useCurrentOrganization();
  const [showModal, setShowModal] = useState(false);

  const displayName = name && name !== "—" ? name : "—";
  const isClickable = displayName !== "—";

  const handleClick = () => {
    if (isClickable) setShowModal(true);
  };

  return (
    <>
      <span
        role={isClickable ? "button" : undefined}
        tabIndex={isClickable ? 0 : undefined}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (isClickable && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            setShowModal(true);
          }
        }}
        className={
          isClickable
            ? "text-cyan-600 hover:underline cursor-pointer font-semibold"
            : "text-gray-700"
        }
      >
        {displayName}
      </span>
      {showModal && organization && (
        <PractitionerInfoModal
          orgId={organization.id}
          ehrProvider={organization.ehr_provider}
          practitionerId={practitionerId ?? null}
          practitionerName={displayName !== "—" ? displayName : undefined}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default PractitionerLink;
